import { useNavigate } from 'react-router-dom';
import { useApp } from '../context/AppContext';
import { TypeTheme } from '../lib/types';
import { grad } from '../components/ui';

export function Library() {
  const navigate = useNavigate();
  const { libraryProducts } = useApp();

  return (
    <div style={{ paddingTop: 20 }}>
      <h1 style={{ fontSize: 24, fontWeight: 900 }}>My Library</h1>
      <p className="muted" style={{ marginBottom: 18 }}>Everything you own, ready to study</p>

      {libraryProducts.length === 0 ? (
        <div className="col center" style={{ padding: 50, gap: 8, textAlign: 'center' }}>
          <div style={{ fontSize: 52 }}>📭</div>
          <div style={{ fontWeight: 800 }}>Your library is empty</div>
          <p className="muted" style={{ maxWidth: 340 }}>Buy notes, PYQs or test series and they&apos;ll show up here for lifetime access.</p>
          <button className="btn btn-primary" style={{ marginTop: 8 }} onClick={() => navigate('/store')}>Browse store</button>
        </div>
      ) : (
        <div className="grid grid-2">
          {libraryProducts.map((p) => {
            const t = TypeTheme[p.type];
            const playable = p.type === 'quiz' || p.type === 'pyq' || p.type === 'test-series';
            return (
              <div key={p.id} className="card">
                <div className="row gap12">
                  <div className="thumb" style={{ ...grad(p.gradient), width: 56, height: 56, fontSize: 26 }}>{p.emoji}</div>
                  <div style={{ flex: 1 }}>
                    <span className="badge tc-badge" style={{ ['--c' as string]: t.color } as React.CSSProperties}>{t.label}</span>
                    <div style={{ fontWeight: 700, fontSize: 14, marginTop: 4 }}>{p.title}</div>
                    <div className="muted" style={{ fontSize: 12, marginTop: 2 }}>★ {p.rating.toFixed(1)} · {p.author}</div>
                  </div>
                </div>
                <div className="row gap8" style={{ marginTop: 12 }}>
                  <div style={{ flex: 1, height: 7, borderRadius: 4, background: 'var(--divider)', overflow: 'hidden' }}>
                    <div style={{ width: '35%', height: '100%', background: t.color }} />
                  </div>
                  <span className="muted" style={{ fontSize: 12, fontWeight: 700 }}>35%</span>
                </div>
                <button
                  className="btn btn-primary btn-block btn-sm"
                  style={{ marginTop: 12 }}
                  onClick={() => navigate(playable ? `/practice/${p.id}` : `/product/${p.id}`)}
                >
                  {playable ? '▶ Start' : '📖 Open'}
                </button>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
